import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import type { IconType } from 'react-icons';

const { FiShield, FiCpu, FiGift } = FiIcons;

const FEATURES: Array<{ icon: IconType; label: string }> = [
  { icon: FiShield, label: 'Private, no-upload conversion' },
  { icon: FiCpu, label: 'Fast browser processing' },
  { icon: FiGift, label: 'Free image converter' },
];

const container = { hidden: {}, show: { transition: { staggerChildren: 0.1 } } };
const item = { hidden: { opacity: 0, y: 20 }, show: { opacity: 1, y: 0 } };

const Hero = () => (
  <section aria-label="Introduction" className="text-center py-14 px-4 max-w-3xl mx-auto">
    <motion.div variants={container} initial="hidden" animate="show">
      <motion.div variants={item}>
        <span className="inline-block text-xs font-bold tracking-widest uppercase text-indigo-700 dark:text-cyan-200 bg-indigo-50 dark:bg-indigo-950/40 px-4 py-1.5 rounded-full mb-6 border border-indigo-200 dark:border-indigo-800">
          Free · Private · No uploads
        </span>
      </motion.div>
      <motion.h1
        variants={item}
        className="text-4xl md:text-6xl font-black mb-5 text-slate-900 dark:text-white leading-tight tracking-tight text-balance"
      >
        Free Batch Image Converter for{' '}
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-cyan-500">
          HEIC, TIFF, PNG, JPG & WEBP
        </span>
      </motion.h1>
      <motion.p
        variants={item}
        className="text-lg md:text-xl text-slate-500 dark:text-slate-400 mb-4 max-w-2xl mx-auto leading-relaxed"
      >
        Convert HEIC to JPG, PNG to WEBP, TIFF to PNG and more in bulk, directly in your browser.
        Your photos stay local, with no uploads, accounts, or server processing.
      </motion.p>
      <motion.p
        variants={item}
        className="text-sm text-slate-400 dark:text-slate-500 mb-10 max-w-xl mx-auto"
      >
        Supports <strong className="text-slate-600 dark:text-slate-300">HEIC · HEIF · TIFF · AVIF · PNG · JPG · WEBP</strong> with custom quality and resize settings.
      </motion.p>
      <motion.div variants={item} className="flex flex-wrap justify-center gap-3">
        {FEATURES.map(({ icon, label }, i) => (
          <div key={i} className="flex items-center gap-2 text-sm font-medium text-slate-600 dark:text-slate-300 bg-white dark:bg-slate-800/80 py-2 px-4 rounded-full shadow-sm border border-slate-200 dark:border-slate-700">
            <SafeIcon icon={icon} className="text-cyan-600 dark:text-cyan-300 shrink-0" />
            <span>{label}</span>
          </div>
        ))}
      </motion.div>
    </motion.div>
  </section>
);

export default Hero;
